import { render, staticRenderFns } from "./VideoSettingWidget.vue?vue&type=template&id=eb311c3e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./VideoSettingWidget.vue?vue&type=script&lang=js&"
export * from "./VideoSettingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb311c3e",
  null
  
)

export default component.exports